export const entryTypes = [
  {
    id: "official",
    name: "官网入口",
    short: "识别主站门面",
    icon: "ri-store-2-line",
    desc: "官网入口通常指平台对外展示的主站页面，是确认平台身份、查看常规栏目与基础说明的第一站。",
    points: [
      "以相对稳定的栏目结构与惯用页面样式为特征",
      "一般承载公告、栏目导航与基础的说明信息",
      "访问前建议先整体浏览，核对页面是否与往常一致",
    ],
  },
  {
    id: "latest",
    name: "最新地址",
    short: "跟随地址变化",
    icon: "ri-link",
    desc: "最新地址指当前可正常访问的站点地址。地址可能因线路或服务调整而变化，建议通过固定的长期渠道获取。",
    points: [
      "地址变化多与线路切换或服务调整有关",
      "优先使用长期关注、可反复核对的固定渠道",
      "避免从陌生弹窗或不明来源直接跳转访问",
    ],
  },
  {
    id: "publish",
    name: "发布页",
    short: "集中的更新出口",
    icon: "ri-megaphone-line",
    desc: "发布页用于集中同步地址与访问说明，是查找最新地址时最常用的参考页面，通常结构简单、以信息同步为主。",
    points: [
      "一般只做信息同步，栏目结构较为简洁",
      "相关更新通常集中在同一个页面发布",
      "适合作为长期收藏的参考入口反复查看",
    ],
  },
  {
    id: "permanent",
    name: "永久入口",
    short: "长期可记的入口",
    icon: "ri-anchor-line",
    desc: "永久入口指不易随具体地址变化而失效的固定入口或说明页，便于长期收藏与反复查找，是防走失的关键习惯。",
    points: [
      "强调长期可记、便于收藏与反复访问",
      "常与发布页配合使用，形成稳定的查找路径",
      "收藏之后仍应以发布页的最新信息为准",
    ],
  },
  {
    id: "antilost",
    name: "防走失",
    short: "找回站点的习惯",
    icon: "ri-compass-3-line",
    desc: "防走失指通过固定渠道、收藏与记录等习惯，在地址发生变化后仍能顺利找回站点的一套做法，重在长期坚持。",
    points: [
      "收藏官方说明页，而不是只记单一地址",
      "记录固定的查找渠道与查看方式",
      "不轻信需要额外下载或付费的所谓指引",
    ],
  },
];

export const quickEntries = [
  {
    id: "entries",
    title: "入口类型说明",
    desc: "官网入口、最新地址、发布页与永久入口分别指什么，一次看清。",
    icon: "ri-door-open-line",
  },
  {
    id: "categories",
    title: "栏目概览",
    desc: "电影、剧集、综艺、动漫等常见栏目的大致分布与浏览方式。",
    icon: "ri-layout-grid-line",
  },
  {
    id: "guide",
    title: "访问与防走失指南",
    desc: "从收藏到核对，一步步养成稳定找到站点的习惯。",
    icon: "ri-route-line",
  },
  {
    id: "faq",
    title: "常见问题",
    desc: "关于地址变化、访问异常与安全提醒的高频疑问解答。",
    icon: "ri-question-line",
  },
];

export const categories = [
  { id: "movie", name: "电影", group: "影视", icon: "ri-film-line", desc: "按题材与年份陈列的影片内容，常见动作、剧情、喜剧等分类。", note: "多为单片条目，按片名或类型浏览" },
  { id: "series", name: "剧集", group: "影视", icon: "ri-clapperboard-line", desc: "连续剧与网络剧的更新集合，通常按集数与更新进度排列。", note: "以更新进度为线索，便于追更" },
  { id: "variety", name: "综艺", group: "节目", icon: "ri-mic-line", desc: "真人秀、访谈与舞台类节目，多按播出期数成组呈现。", note: "常按期数成组，适合按周查看" },
  { id: "anime", name: "动漫", group: "影视", icon: "ri-emotion-happy-line", desc: "动画剧集与剧场版动画，常按季度或作品系列归类。", note: "按季度或作品系列归拢" },
  { id: "doc", name: "纪录片", group: "节目", icon: "ri-earth-line", desc: "自然、人文与历史类纪实内容，多为分集或系列形式。", note: "分集或系列形式为主" },
  { id: "short", name: "短剧", group: "影视", icon: "ri-smartphone-line", desc: "单集时长较短的竖屏或横屏内容，节奏紧凑、更新较快。", note: "集数多、单集短，适合片段浏览" },
  { id: "sports", name: "体育", group: "节目", icon: "ri-basketball-line", desc: "赛事集锦与运动专题，常按赛程或赛事类别整理。", note: "按赛程或赛事类别整理" },
  { id: "kids", name: "少儿", group: "影视", icon: "ri-bear-smile-line", desc: "面向少儿的动画与益智内容，画面较为明快、语言浅显。", note: "内容分级清晰，便于家长筛选" },
];

export const categoryGroups = ["全部", "影视", "节目"];

export const guideSteps = [
  {
    step: "01",
    title: "先收藏稳定的参考页",
    desc: "把发布页或说明页加入收藏夹，而不是只记住某一个具体地址，这样地址变化时仍能回到同一起点。",
    icon: "ri-bookmark-3-line",
  },
  {
    step: "02",
    title: "通过固定渠道获取地址",
    desc: "每次查找都从同一类固定渠道出发，形成稳定的路径，避免依赖随机搜索到的陌生结果。",
    icon: "ri-search-eye-line",
  },
  {
    step: "03",
    title: "进入前先做基本核对",
    desc: "打开页面后先看整体栏目与公告是否与往常一致，确认无误再继续浏览，减少误入相似页面的可能。",
    icon: "ri-shield-check-line",
  },
  {
    step: "04",
    title: "遇到异常先停一停",
    desc: "若出现额外的下载要求、付费提示或异常弹窗，建议先暂停操作，回到发布页重新核对信息。",
    icon: "ri-error-warning-line",
  },
  {
    step: "05",
    title: "定期回看更新说明",
    desc: "隔一段时间回看发布页的更新说明，了解栏目或说明是否有调整，让查找习惯保持有效。",
    icon: "ri-refresh-line",
  },
];

export const publishNotes = [
  {
    title: "为什么地址会发生变化",
    desc: "地址调整通常与线路切换、服务维护或访问环境变化有关，属于常见的运营情况，并不代表平台停止服务。",
    icon: "ri-swap-box-line",
  },
  {
    title: "发布页一般会同步什么",
    desc: "发布页通常集中说明当前可用的地址、访问方式与必要提醒，信息相对精简，便于快速查看。",
    icon: "ri-file-list-3-line",
  },
  {
    title: "何时应回到发布页",
    desc: "当原地址无法打开、页面内容明显异常，或长时间未访问时，回到发布页重新核对是更稳妥的做法。",
    icon: "ri-arrow-go-back-line",
  },
  {
    title: "怎样理解永久入口",
    desc: "永久入口强调长期可记与便于收藏，通常不会有太大变化，但仍建议与发布页信息互相印证，避免只看一处。",
    icon: "ri-links-line",
  },
];

export const maintenanceNotes = [
  {
    tag: "地址维护",
    title: "线路切换期间的说明",
    desc: "线路调整期间，个别地址可能暂时无法访问。此时以发布页同步的信息为准，耐心更换入口通常即可恢复正常浏览。",
    icon: "ri-router-line",
  },
  {
    tag: "栏目说明",
    title: "栏目结构与分类调整",
    desc: "栏目分类可能随内容积累而做小幅整理，名称或归组略有变化属于正常情况，整体浏览方式基本保持一致。",
    icon: "ri-node-tree",
  },
  {
    tag: "访问提醒",
    title: "安全访问的日常建议",
    desc: "建议保持系统与浏览器更新，不随意下载来源不明的程序，也不在可疑页面填写敏感信息。",
    icon: "ri-lock-2-line",
  },
  {
    tag: "使用习惯",
    title: "保持固定的查找路径",
    desc: "长期使用同一套固定渠道与收藏习惯，能够在地址变化时更快找回站点，也更容易分辨信息是否可靠。",
    icon: "ri-repeat-2-line",
  },
];

export const faqs = [
  {
    q: "大师兄影视的最新地址应该去哪里查看？",
    a: "最新地址通常会集中发布在发布页，并配合官网入口与永久入口一起使用。建议固定收藏同一类参考页面，每次从其出发查找，比每次重新搜索更稳妥。",
  },
  {
    q: "官网入口、官方网址和发布页有什么区别？",
    a: "官网入口偏向平台对外展示的主站页面；官方网址指平台惯用的正式访问地址；发布页则用于集中同步地址与访问说明。三者用途不同，实际查找时通常互相印证。",
  },
  {
    q: "什么是防走失？我需要做什么？",
    a: "防走失是一套长期习惯：把说明页或发布页加入收藏、固定使用同一渠道查找、进入前做基本核对。它不依赖某一个具体地址，因此在地址变化后仍能找回站点。",
  },
  {
    q: "原来的地址打不开，是不是平台停止运营了？",
    a: "地址打不开通常与线路切换或服务维护有关，并不能直接说明平台停止服务。更稳妥的做法是回到发布页核对当前可用地址，而不是据单一地址的失效下结论。",
  },
  {
    q: "永久入口是不是绝对不会失效？",
    a: "永久入口强调长期可记与便于收藏，相对稳定，但没有任何入口能保证永远不变。仍建议把它与发布页一起使用，以发布页的最新信息为准。",
  },
  {
    q: "访问时出现额外下载或付费提示怎么办？",
    a: "遇到要求额外下载、付费或填写敏感信息的提示，建议先暂停操作，回到发布页重新核对该地址是否为当前可用入口，避免在不确认的页面继续操作。",
  },
];